import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { faExclamationTriangle } from '@fortawesome/free-solid-svg-icons';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { RowEvent } from '../../../../../shared/components/table/table-row/table-row.component';
import { TableColumn, TableSettings, AddEvent } from '../../../../../shared/components/table/table.component';
import { APINetworkLicense, LicenseService } from '../../../../../shared/services/license.service';
import { ToastService } from '../../../../../shared/services/toast.service';

@Component({
  selector: 'app-network',
  templateUrl: './network.component.html',
  styleUrls: ['./network.component.scss']
})
export class NetworkComponent implements OnInit {

  licenses: APINetworkLicense[] = [];

  baseURL: string = "/admin/licenses/network"

  columns: TableColumn[] = [
    new TableColumn("view.admin.licenses.network.name", "name"),
    new TableColumn("view.admin.licenses.network.price", "price", true, true, "", "kr"),
    new TableColumn("view.admin.licenses.network.sites", "nr_sites"),
    new TableColumn("view.admin.licenses.network.users", "nr_users"),
  ];

  settings: TableSettings = new TableSettings("view.admin.licenses.network.title");
  actions: string[];
  actionMap: { [id: string]: (c: APINetworkLicense) => void } = {
    "buttons.view": this.view.bind(this),
    "buttons.edit": this.edit.bind(this),
    "buttons.delete": this.delete.bind(this),
  }

  @ViewChild("confirm") modal: ElementRef;
  warning = faExclamationTriangle;
  loading: boolean = true;

  constructor(
    private _licenseService: LicenseService,
    private _router: Router,
    private _toastService: ToastService,
    private _modalService: NgbModal,
  ) { }

  ngOnInit(): void {
    this.actions = Object.keys(this.actionMap)
    this._licenseService.networkList().subscribe(
      (licenses: APINetworkLicense[]) => {
        this.licenses = licenses
        this.loading = false;
      }
    )
  }

  onAction(event: RowEvent) { let f = this.actionMap[event.action]; f(event.item); }

  onAdd(_: AddEvent) {
    this._router.navigateByUrl(`${this.baseURL}/new`)
  }

  view(r: APINetworkLicense) {
    this._router.navigateByUrl(`${this.baseURL}/${r.id}`)
  }

  edit(r: APINetworkLicense) {
    this._router.navigateByUrl(`${this.baseURL}/${r.id}/edit`)
  }

  delete(r: APINetworkLicense) {
    this._modalService.open(this.modal, {
      centered: true,
      backdrop: "static",
    }).result.then((ok: boolean) => {
      if (!ok) return
      this._licenseService.networkDelete(r.id).subscribe(
        () => {
          this.licenses = this.licenses.filter((e: APINetworkLicense) => { return e.id !== r.id; })
          this._toastService.saved()
        }, (error: any) => {
          this._toastService.server()
        });
    });
  }

}
